import { configureStore } from '@reduxjs/toolkit'

import authReducer from 'features/auth/';
import categoriesReducer from 'features/categories';
import gamesReducer from 'features/games/';
import jackpotsReducer from 'features/jackpots';
import menuReducer from 'features/menu';
import userReducer from 'features/user';
import vendorsReducer from 'features/vendors';
import sectionsReducer from 'features/sections'

import SocketWrapper from './websocket/wrapper';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        categories: categoriesReducer,
        games: gamesReducer,
        jackpots: jackpotsReducer,
        menu: menuReducer,
        user: userReducer,
        vendors: vendorsReducer,
        sections: sectionsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: {
                extraArgument: { socket: new SocketWrapper() },
            },
        }),
});